import { render, staticRenderFns } from "./StandardFormRow.vue?vue&type=template&id=64a0c2ac&scoped=true"
import script from "./StandardFormRow.vue?vue&type=script&lang=js"
export * from "./StandardFormRow.vue?vue&type=script&lang=js"
import style0 from "./StandardFormRow.vue?vue&type=style&index=0&id=64a0c2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0c2ac",
  null
  
)

export default component.exports